module.exports = __webpack_public_path__ + "212f9af46c4633354e221479b215db05.jpg";